import React from 'react';
import { useTranslation } from 'react-i18next';
import { BusinessOperationsKeys } from '../../pages/BusinessOperations/BusinessOperations';
import { OperationDataClass, OperationFieldProps } from '../../types/assessment_info/gev/BusinessOperationFormProps';
import { useBusinessOperationsState } from '../../utils/context/BusinessOperationsContext';
import { useReadOnly } from '../../utils/ReadOnlyContext';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';
import Input from '../common/Input/Input';
import "./GEV.css";

export default function GEVInput(props: OperationFieldProps): JSX.Element {
    const { operation, name } = props;
    const { t } = useTranslation('gev')
    const { isReadOnly } = useReadOnly()
    const { formData, setFormData } = useBusinessOperationsState();

    const handleChange = (value: string | number | null) => {
        props.removeError && props.removeError(name)

        setFormData((prevData) => ({
            ...prevData,
            [operation]: {
                ...prevData[operation as BusinessOperationsKeys],
                [name]: value === "" ? null : value,
            },
        }));
    };

    const currentValue = formData[operation as BusinessOperationsKeys]?.[name as keyof OperationDataClass] ?? '';
    return (
        <>
            <tr className='gev-input-tr'>
                <td className='index'>
                    {props.index && props.index + "."}
                </td>
                <td>
                    <div className='gev-input-label'>
                        {t(operation + "." + name)}
                    </div>
                    {
                        props.type === "number" ?
                            <>
                                <AIRPNumberInput
                                    formatType="decimal"
                                    name={operation + "." + name}
                                    initialValue={currentValue as unknown as string}
                                    className={'gev-number-input-100' + (props.hasErrors ? ' form-error' : '')}
                                    readOnly={isReadOnly}
                                    onChange={(value: number | null) => handleChange(value)}
                                />
                            </>
                            :
                            <>
                                <Input type={"text"}
                                    id={operation + "." + name}
                                    name={operation + "." + name}
                                    value={currentValue as unknown as string}
                                    className={'gev-input-100' + (props.hasErrors ? ' form-error' : '')}
                                    title={t(operation + "." + name)}
                                    ariaLabel={t(operation + "." + name)}
                                    autoComplete="off"
                                    disabled={isReadOnly}
                                    onChange={(e) => handleChange(e.target.value)}
                                />
                            </>
                    }
                    <div className="input-error-message">
                        {props.errors && props.errors[name] as string}
                    </div>
                </td>
            </tr>
        </>
    )
}
